import { memo, useCallback } from 'react'

import { Divider } from '@mui/material'
import { MediaLibraryEntry } from '@nativewaves/nw-cloud-sdk/media'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useMediaLibraryMediaDeleteMutation } from 'hooks/mutations/publishing'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<MediaLibraryEntry>) => {
  const { t } = useTranslation(['common', 'entity', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: deleteMediaLibraryObject } = useMediaLibraryMediaDeleteMutation()

  const handleDeleteMediaLibraryObject = useCallback(() => {
    onClose()

    deleteMediaLibraryObject(
      { libraryId: row.original.libraryId, mediaId: row.original.id },
      {
        onSuccess: () =>
          enqueueSnackbar(t('domain:MediaLibrary.nameDelete', { name: row.original.name }), { variant: 'success' }),
      },
    )
  }, [
    deleteMediaLibraryObject,
    enqueueSnackbar,
    onClose,
    row.original.id,
    row.original.libraryId,
    row.original.name,
    t,
  ])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemDelete onConfirm={handleDeleteMediaLibraryObject} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
